


























import Vue from 'vue';
import VeLine from 'v-charts/lib/line.common';
import customerClient from '../../apis';
import moment from 'moment';

export default Vue.extend({
  components: {
    VeLine,
  },
  props: {
    ruleId: {
      type: Number,
      default: null,
    },
    type: {
      type: Number,
      default: null,
    },
    sid: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD'),
      options2: {},
      loading: false,
      legend: {
        show: false,
      },
      chartTheme: {
        valueAxis: {
          splitLine: {
            lineStyle: {
              color: '#cccccc',
              type: 'dotted',
            },
          },
        },
      },
      chartSettings: {
        stack: { 'date': ['count']},
        area: true,
        labelMap: {
          count: '发送数',
        },
        lineStyle: {
          color: '#1790FF',
        },
      },
      chartData: {
        columns: ['date', 'count'],
        rows: [],
      },
      chartExtend: {
        series: {
          symbol: 'none',
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#ccc',
            },
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {show: false}, 
        },
      },
      colors: ['#C2DEFF'],
    };
  },
  methods: {
    confirmDate(dates: any) {
      this.start = moment(dates[0]).format('YYYY-MM-DD');
      this.end = moment(dates[1]).format('YYYY-MM-DD');
      this.getTrendsData();
    },
    getTrendsData() {
      this.loading = true;
      customerClient.getRemarkRuleTrends({
        ruleId: this.ruleId,
        type: this.type,
        sid: this.sid,
        start: this.start,
        end: this.end,
      }).success((res) => {
        this.chartData.rows = res.map((r: any) => this.getRowData(r));
        this.loading = false;
      });
    },
    getRowData(item: any) {
      return {date: moment(item.day).format('YYYY-MM-DD'), count: item.count};
    },
  },
  mounted() {
    this.getTrendsData();
  },
});
